import React from 'react';
import { IconButton, Box } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useHistory } from 'react-router-dom';
import { CreditAppTableRow } from 'modules/customers/types';

interface Props {
  row: CreditAppTableRow;
}

export const CreditAppsTableActionCell = ({ row }: Props) => {
  const handleGoToOpportunity = () => {
    window.open(`/vo/${row.vendorOpportunityId}`, '_blank');
  };

  return (
    <Box>
      <IconButton color="primary" size="small" onClick={() => handleGoToOpportunity()}>
        <OpenInNewIcon />
      </IconButton>
    </Box>
  );
};
